import type { FolderNode } from '../api/types';
import type { ViewMode } from './DocumentList';
import { Chip } from './ui/Chip';
import { Icon } from './ui/Icon';

export interface FolderRowsProps {
  folders: readonly FolderNode[];
  view: ViewMode;
  /** Single click enters the folder, like a desktop file manager. */
  onOpen: (folder: FolderNode) => void;
}

/** The selected folder's subfolders, listed above its files as rows (list) or tiles (grid). */
export function FolderRows({ folders, view, onOpen }: FolderRowsProps) {
  if (folders.length === 0) return null;
  return (
    <ul aria-label="Subfolders" className={view === 'grid' ? 'gsl-folder-grid' : 'gsl-folder-rows'}>
      {folders.map((f) => (
        <li key={f.id}>
          <button type="button" className="gsl-folder-row" onClick={() => onOpen(f)} data-folder-id={f.id}>
            <Icon name="folder" size={view === 'grid' ? 28 : 18} className="shrink-0 text-muted-foreground" />
            <span className="truncate">{f.name}</span>
            {f.status === 'archived' ? <Chip variant="neutral">archived</Chip> : null}
            {typeof f.documentCount === 'number' ? <span className="gsl-num ml-auto text-xs text-muted-foreground">{f.documentCount}</span> : null}
          </button>
        </li>
      ))}
    </ul>
  );
}
